import { LocaleEnum } from '@systemeio/ui'

export const getMollieHelpPageLink = (locale?: LocaleEnum) => {
  switch (locale) {
    case LocaleEnum.DUTCH: {
      return 'https://help-nl.systeme.io/article/1981-hoe-integreer-je-mollie-met-systeme-io'
    }
    case LocaleEnum.DEUTSCH: {
      return 'https://help-de.systeme.io/article/1977-mollie'
    }
    case LocaleEnum.FRENCH: {
      return 'https://aide.systeme.io/article/1968-comment-integrer-mollie-a-systeme-io'
    }
    case LocaleEnum.JAPANESE: {
      return 'https://help-jp.systeme.io/article/2504-how-to-integrate-mollie-with-systeme-io'
    }
    case LocaleEnum.PORTUGUESE: {
      return 'https://help-pt.systeme.io/article/1985-como-integrar-o-processador-de-pagamentos-mollie-a-systeme-io'
    }
    case LocaleEnum.SPANISH: {
      return 'https://help-es.systeme.io/article/1972-como-integrar-mollie-con-systeme-io'
    }
    case LocaleEnum.ITALIAN: {
      return 'https://help-it.systeme.io/article/1976-come-integrare-mollie-con-systeme-io'
    }
    default: {
      return 'https://help.systeme.io/article/1965-how-to-integrate-mollie-with-systeme-io'
    }
  }
}
